(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function initMastNavIndicator() {
      var nav = document.querySelector('.mast-nav');
      if (!nav) return;
      var indicator = nav.querySelector('.mast-nav__indicator');
      var targets = nav.querySelectorAll('.mast-nav__trigger, .mast-nav__link');
      if (!indicator || !targets.length) return;

      function moveTo(el) {
        if (!el) return;
        indicator.style.transform = 'translateX(' + el.offsetLeft + 'px)';
        indicator.style.width = el.offsetWidth + 'px';
        nav.classList.add('is-indicator-active');
      }
      function hide() {
        nav.classList.remove('is-indicator-active');
      }

      targets.forEach(function (target) {
        var item = target.closest('.mast-nav__item');
        var hoverArea = item || target;
        hoverArea.addEventListener('mouseenter', function () { moveTo(target); });
        target.addEventListener('focus', function () { moveTo(target); });
        if (target.classList.contains('mast-nav__trigger')) {
          target.addEventListener('mousedown', function (e) { e.preventDefault(); });
        }
      });

      nav.addEventListener('mouseleave', hide);
      nav.addEventListener('focusout', function (e) {
        if (!nav.contains(e.relatedTarget)) hide();
      });

      window.addEventListener('resize', hide);
    }

    function initMastPanelTop() {
      var header = document.querySelector('.section-header');
      if (!header) return;
      function update() {
        var bottom = header.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--mast-panel-top', Math.max(0, Math.round(bottom)) + 'px');
      }
      update();
      window.addEventListener('load', update);
      window.addEventListener('resize', update);
      var toggle = document.getElementById('mast-mobile-toggle');
      if (toggle) toggle.addEventListener('change', update);
    }

    function initMastHeader() {
      initMastNavIndicator();
      initMastPanelTop();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMastHeader);
    } else {
      initMastHeader();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
